import { render, staticRenderFns } from "./OrderAssistances.vue?vue&type=template&id=64739d9f&"
import script from "./OrderAssistances.vue?vue&type=script&lang=js&"
export * from "./OrderAssistances.vue?vue&type=script&lang=js&"
import style0 from "./OrderAssistances.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports